import React from 'react';

/**
 * Как активировать выданные коды. У кодов поставщика (Apple, Roblox и других) своя
 * инструкция — ее присылает бэкенд вместе с заказом; коды PlayStation — с привычной
 * инструкцией для PS5 и PS4. То же правило, что на сайте.
 */

const PS_INSTRUCTIONS = [
  'Как использовать код на PS5:',
  '• Зайдите в свой зарубежный аккаунт и откройте PS Store.',
  '• Нажмите сверху справа на три точки.',
  '• Выберите Redeem Code.',
  '• Введите код без дефисов и тире.',
  '• Нажмите Redeem. Баланс пополнен!',
  '',
  'Как использовать код на PS4:',
  '• Зайдите в свой зарубежный аккаунт и откройте PS Store.',
  '• Пролистайте вниз до пункта Redeem Code.',
  '• Выберите Redeem Code.',
  '• Введите код без дефисов и тире.',
  '• Нажмите Continue. Баланс пополнен!',
].join('\n');

interface Props {
  approute?: { serviceKey?: string; instructions?: string } | null;
}

export const CodeInstructions: React.FC<Props> = ({ approute }) => {
  const otherService = Boolean(approute?.serviceKey) && approute?.serviceKey !== 'playstation';
  if (otherService && !approute?.instructions) return null;
  const text = otherService ? String(approute?.instructions) : PS_INSTRUCTIONS;

  // Абзацы разделены пустой строкой; первая строка абзаца с двоеточием на конце — заголовок
  return (
    <div className="rounded-xl p-3 mt-2.5" style={{ background: '#FFF8EB' }}>
      {text.split(/\n\s*\n/).map((block, i) => {
        const [first, ...rest] = block.split('\n');
        const heading = first.trim().endsWith(':') ? first : null;
        const body = heading ? rest.join('\n') : block;
        return (
          <div key={i} style={i > 0 ? { marginTop: '10px' } : undefined}>
            {heading && (
              <p style={{ fontFamily: 'Manrope, sans-serif', fontWeight: 600, fontSize: '13px', lineHeight: '18px', color: '#92400E', marginBottom: '6px' }}>
                {heading}
              </p>
            )}
            {body && (
              <p style={{ fontFamily: 'Manrope, sans-serif', fontWeight: 400, fontSize: '12px', lineHeight: '18px', color: '#B45309', whiteSpace: 'pre-line' }}>
                {body}
              </p>
            )}
          </div>
        );
      })}
    </div>
  );
};
